import React, { useState, useRef, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import api from '../api';
import Header from '../Components/Header';

const VerifyEmail = () => {
    const navigate = useNavigate();

    const location = useLocation();
    const email = location.state?.email;
    const [verificationCode, setVerificationCode] = useState(['', '', '', '', '', '']);
    const inputRefs = useRef([]);

    useEffect(() => {
        inputRefs.current = inputRefs.current.slice(0, 6);
    }, []);

    const handleChange = (index, value) => {
        if (!/^\d*$/.test(value)) return;

        const newVerificationCode = [...verificationCode];
        newVerificationCode[index] = value;
        setVerificationCode(newVerificationCode);

        if (value !== '' && index < 5) {
            inputRefs.current[index + 1].focus();
        }
    };

    const handleKeyDown = (index, e) => {
        if (e.key === 'Backspace' && verificationCode[index] === '' && index > 0) {
            inputRefs.current[index - 1].focus();
        }
    };

    const handlePaste = (e) => {
        e.preventDefault();
        const pastedData = e.clipboardData.getData('text').match(/\d/g)?.slice(0, 6);
        if (pastedData) {
            const newVerificationCode = [...verificationCode];
            pastedData.forEach((digit, index) => {
                if (index < 6) newVerificationCode[index] = digit;
            });
            setVerificationCode(newVerificationCode);
        }
    };

    // 쿠키 가져오기
    const getCookie = (name) => {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
        return null;
      };

    const handleSubmit = async () => {
        const code = verificationCode.join('');
        const referralCode = getCookie('referral_code'); // 추천인 쿠키
        try {
            const response = await api.post('users/verify-email/', {
                email: email,
                code: code,
                referral_code: referralCode
            });

            navigate('/');

        } catch (error) {
            if (error.response) {
                // 서버가 응답을 반환했지만 에러 상태코드인 경우
                console.error('인증 실패:', error.response.data);
                alert(error.response.data.message || '인증에 실패했습니다.');
            } else if (error.request) {
                //요청은 보냈지만 응답을 받지 못한 경우
                console.error('서버 응답 없음:', error.request);
                alert('서버와의 통신에 실패했습니다.');
            } else {
                // 요청 전송 전에 발생한 에러
                console.error('요청 오류:', error.message);
                alert('요청 중 오류가 발생했습니다.');
            }

        }
    };

    const handleResendEmail = async () => {
        try {
            const response = await api.post('users/resend-verification/', {
                email: email
            });
            alert('인증 메일이 재발송되었습니다.');
        } catch (error) {
            alert('이메일 발송에 실패했습니다. 다시 시도해주세요.');
        }
    }


    const isComplete = verificationCode.every(digit => digit !== '');

    return (
        <div className="bg-white">
      <Header />
        <div className="min-h-screen flex items-center justify-center">
            <div className="w-full max-w-md px-6 py-8">
                <div className="text-center">
                    <div className="w-24 h-24 bg-gray-100 rounded-full mx-auto mb-4 flex items-center justify-center">
                        <div className="relative">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-12 w-12 text-gray-400"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                                />
                            </svg>
                            <div className="absolute top-0 right-0 h-3 w-3 bg-green-500 rounded-full"></div>
                        </div>
                    </div>

                    <h2 className="text-xl font-bold mb-2">{email}</h2>
                    <p className="text-gray-600 mb-8">
                        인증번호 이메일을 발송했습니다.<br />
                        받으신 인증번호를 입력해주세요.
                    </p>

                    <div className="flex flex-col items-center gap-6 mb-6">
                        <div className="flex justify-center gap-2">
                            {verificationCode.map((digit, index) => (
                                <input
                                    key={index}
                                    ref={el => inputRefs.current[index] = el}
                                    type="text"
                                    maxLength={1}
                                    value={digit}
                                    onChange={(e) => handleChange(index, e.target.value)}
                                    onKeyDown={(e) => handleKeyDown(index, e)}
                                    onPaste={handlePaste}
                                    className="w-12 h-12 text-center border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                />
                            ))}
                        </div>

                        <button
                            onClick={handleSubmit}
                            disabled={!isComplete}
                            className="w-[296px] py-2 px-4 bg-blue-600 text-white rounded-md font-semibold 
             transition duration-200 hover:bg-blue-700
             disabled:bg-gray-400 disabled:cursor-not-allowed"
                        >
                            인증하기
                        </button>
                    </div>
                    <p className="mt-6 text-sm text-gray-600">
                        이메일을 받지 못하셨나요?{' '}
                        <button
                            onClick={handleResendEmail}
                            className="text-blue-600 hover:text-blue-800"
                        >
                            다시 시도해주세요.
                        </button>
                    </p>
                </div>
            </div>
        </div>
        </div>
    );
};

export default VerifyEmail;